import React from 'react';
import { NCZICompositionItem } from '../../../../Interfaces/ncziTypes';
import EHREntry from '../EHREntry/EHREntry';
import EHREntrySection from '../EHREntry/EHREntrySection';

interface Props {
	item: NCZICompositionItem | undefined;
}

const EHRCompositionItem: React.FC<Props> = props => {
	const { item } = props;

	if (item?.entry) {
		return <EHREntry item={item.entry} />;
	}

	if (item?.section) {
		return <EHREntrySection section={item.section} />;
	}

	return <></>;
};

export default EHRCompositionItem;
